import React, { useState } from 'react'
import styles from './ContactsPage.module.scss'
import { ReactComponent as PhoneIcon } from '../../../../assets/icons/contacts/phone.svg'
import { ReactComponent as EmailIcon } from '../../../../assets/icons/contacts/email.svg'
import { ReactComponent as ChatIcon } from '../../../../assets/icons/contacts/chat.svg'
import { ReactComponent as SocialIcon } from '../../../../assets/icons/contacts/social.svg'
import { ReactComponent as CodeIcon } from '../../../../assets/icons/about/code.svg'
import { ReactComponent as HeadsetIcon } from '../../../../assets/icons/about/headset.svg'

const ContactsPage = ({ goBack }) => {
  const getIcon = (iconName) => {
    const icons = {
      phone: PhoneIcon,
      email: EmailIcon,
      chat: ChatIcon,
      social: SocialIcon,
      code: CodeIcon,
      headset: HeadsetIcon
    }
    const Icon = icons[iconName]
    return Icon ? <Icon className={styles.icon} /> : null
  }

  const [successModal, setSuccessModal] = useState({ show: false, title: '', message: '', isError: false })

  const sendToAPI = async (formType, data) => {
    try {
      const res = await fetch('https://security.ncore.kg/api/feedback/submit/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ form_type: formType, ...data })
      })
      const json = await res.json()
      if (json.ok) {
        setSuccessModal({ show: true, isError: false, title: 'Отправлено!', message: 'Ваша заявка принята. Мы свяжемся с вами в ближайшее время.' })
      } else {
        setSuccessModal({ show: true, isError: true, title: 'Ошибка', message: json.error || 'Не удалось отправить форму.' })
      }
    } catch (e) {
      setSuccessModal({ show: true, isError: true, title: 'Ошибка', message: 'Не удалось отправить форму. Проверьте соединение.' })
    }
  }
  const [consultationForm, setConsultationForm] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  })

  const [supportForm, setSupportForm] = useState({
    name: '',
    email: '',
    issue: '',
    priority: 'medium',
    description: ''
  })

  const [partnerForm, setPartnerForm] = useState({
    company: '',
    name: '',
    email: '',
    phone: '',
    partnership: '',
    message: ''
  })

  const handleConsultationSubmit = (e) => {
    e.preventDefault()
    sendToAPI('consultation', consultationForm)
    setConsultationForm({ name: '', email: '', phone: '', service: '', message: '' })
  }

  const handleSupportSubmit = (e) => {
    e.preventDefault()
    sendToAPI('support', supportForm)
    setSupportForm({ name: '', email: '', issue: '', priority: 'medium', description: '' })
  }

  const handlePartnerSubmit = (e) => {
    e.preventDefault()
    sendToAPI('partnership', partnerForm)
    setPartnerForm({ company: '', name: '', email: '', phone: '', partnership: '', message: '' })
  }

  const contactMethods = [
    {
      icon: 'phone',
      title: 'Телефон',
      value: '0706602834',
      description: 'Звоните нам в любое время',
      color: '#4CAF50'
    },
    {
      icon: 'email',
      title: 'Email',
      value: '@ncore',
      description: 'Мы ответим в течение 24 часов',
      color: '#2196F3'
    },
    {  
      icon: 'chat',
      title: 'Онлайн-чат',
      value: 'Доступен 24/7',
      description: 'Мгновенная поддержка',
      color: '#FF9800'
    },
    {
      icon: 'social',
      title: 'Социальные сети',
      value: '@ncore',
      description: 'Следите за нашими новостями',
      color: '#9C27B0'
    }
  ]

  return (
    <div className={styles.page}>
      {/* <div className={styles.heroSection}>
        <h1 className={styles.heroTitle}>Свяжитесь с нами</h1>
        <p className={styles.heroSubtitle}>Мы всегда на связи</p>
      </div> */}

      <div className={styles.contactMethodsSection}>
        <div className={styles.methodsGrid}>
          {contactMethods.map((method, index) => (
            <div key={index} className={styles.methodCard} style={{ '--accent': method.color }}>
              <div className={styles.methodIcon}>{getIcon(method.icon)}</div>
              <h3 className={styles.methodTitle}>{method.title}</h3>
              <div className={styles.methodValue}>{method.value}</div>
              <p className={styles.methodDescription}>{method.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.formsSection}>
        {/* Consultation Form */}
        <div className={styles.formContainer}>
          <div className={styles.formHeader}>
            <div className={styles.formIcon}>{getIcon('code')}</div>
            <h2 className={styles.formTitle}>Консультация</h2>
            <p className={styles.formDescription}>
              Получите профессиональную консультацию по нашим сервисам
            </p>
          </div>
          <form onSubmit={handleConsultationSubmit} className={styles.form}>
            <div className={styles.formRow}>
              <div className={styles.inputGroup}>
                <label>Ваше имя *</label>
                <input
                  type="text"
                  value={consultationForm.name}
                  onChange={(e) => setConsultationForm({ ...consultationForm, name: e.target.value })}
                  required
                  placeholder="Введите ваше имя"
                />
              </div>
              <div className={styles.inputGroup}>
                <label>Email *</label>
                <input
                  type="email"
                  value={consultationForm.email}
                  onChange={(e) => setConsultationForm({ ...consultationForm, email: e.target.value })}
                  required
                  placeholder="your@email.com"
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.inputGroup}>
                <label>Телефон</label>
                <input
                  type="tel"
                  value={consultationForm.phone}
                  onChange={(e) => setConsultationForm({ ...consultationForm, phone: e.target.value })}
                  placeholder="+996 XXX XXX XXX"
                />
              </div>
              <div className={styles.inputGroup}>
                <label>Интересующий сервис *</label>
                <select
                  value={consultationForm.service}
                  onChange={(e) => setConsultationForm({ ...consultationForm, service: e.target.value })}
                  required
                >
                  <option value="">Выберите сервис</option>
                  <option value="shop">NCORE Shop</option>
                  <option value="food">Доставка еды</option>
                  <option value="it">NCORE IT Услуги</option>
                  <option value="servers">Игровые серверы</option>
                  <option value="community">Сообщество</option>
                  <option value="movie">Фильмы</option>
                  <option value="anime">Аниме</option>
                  <option value="events">Мероприятия</option>
                  <option value="media">Медиа</option>
                  <option value="tourism">Туризм</option>
                </select>
              </div>
            </div>
            <div className={styles.inputGroup}>
              <label>Сообщение *</label>
              <textarea
                value={consultationForm.message}
                onChange={(e) => setConsultationForm({ ...consultationForm, message: e.target.value })}
                required
                rows="4"
                placeholder="Расскажите о вашем запросе..."
              />
            </div>
            <button type="submit" className={styles.submitButton}>
              Отправить запрос
            </button>
          </form>
        </div>

        {/* Support Form */}
        <div className={styles.formContainer}>
          <div className={styles.formHeader}>
            <div className={styles.formIcon}>{getIcon('headset')}</div>
            <h2 className={styles.formTitle}>Техническая поддержка</h2>
            <p className={styles.formDescription}>
              Опишите вашу проблему, и мы поможем её решить
            </p>
          </div>
          <form onSubmit={handleSupportSubmit} className={styles.form}>
            <div className={styles.formRow}>
              <div className={styles.inputGroup}>
                <label>Ваше имя *</label>
                <input
                  type="text"
                  value={supportForm.name}
                  onChange={(e) => setSupportForm({ ...supportForm, name: e.target.value })}
                  required
                  placeholder="Введите ваше имя"
                />
              </div>
              <div className={styles.inputGroup}>
                <label>Email *</label>
                <input
                  type="email"
                  value={supportForm.email}
                  onChange={(e) => setSupportForm({ ...supportForm, email: e.target.value })}
                  required
                  placeholder="your@email.com"
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.inputGroup}>
                <label>Проблема *</label>
                <input
                  type="text"
                  value={supportForm.issue}
                  onChange={(e) => setSupportForm({ ...supportForm, issue: e.target.value })}
                  required
                  placeholder="Кратко опишите проблему"
                />
              </div>
              <div className={styles.inputGroup}>
                <label>Приоритет *</label>
                <select
                  value={supportForm.priority}
                  onChange={(e) => setSupportForm({ ...supportForm, priority: e.target.value })}
                  required
                >
                  <option value="low">Низкий</option>
                  <option value="medium">Средний</option>
                  <option value="high">Высокий</option>
                  <option value="critical">Критический</option>
                </select>
              </div>
            </div>
            <div className={styles.inputGroup}>
              <label>Подробное описание *</label>
              <textarea
                value={supportForm.description}
                onChange={(e) => setSupportForm({ ...supportForm, description: e.target.value })}
                required
                rows="4"
                placeholder="Опишите проблему подробно..."
              />
            </div>
            <button type="submit" className={styles.submitButton}>
              Отправить в поддержку
            </button>
          </form>
        </div>

        {/* Partnership Form */}
        <div className={styles.formContainer}>
          <div className={styles.formHeader}>
            <div className={styles.formIcon}>{getIcon('social')}</div>
            <h2 className={styles.formTitle}>Партнерство</h2>
            <p className={styles.formDescription}>
              Заинтересованы в сотрудничестве? Давайте обсудим!
            </p>
          </div>
          <form onSubmit={handlePartnerSubmit} className={styles.form}>
            <div className={styles.formRow}>
              <div className={styles.inputGroup}>
                <label>Название компании *</label>
                <input
                  type="text"
                  value={partnerForm.company}
                  onChange={(e) => setPartnerForm({ ...partnerForm, company: e.target.value })}
                  required
                  placeholder="Ваша компания"
                />
              </div>
              <div className={styles.inputGroup}>
                <label>Контактное лицо *</label>
                <input
                  type="text"
                  value={partnerForm.name}
                  onChange={(e) => setPartnerForm({ ...partnerForm, name: e.target.value })}
                  required
                  placeholder="Ваше имя"
                />
              </div>
            </div>
            <div className={styles.formRow}>
              <div className={styles.inputGroup}>
                <label>Email *</label>
                <input
                  type="email"
                  value={partnerForm.email}
                  onChange={(e) => setPartnerForm({ ...partnerForm, email: e.target.value })}
                  required
                  placeholder="company@email.com"
                />
              </div>
              <div className={styles.inputGroup}>
                <label>Телефон *</label>
                <input
                  type="tel"
                  value={partnerForm.phone}
                  onChange={(e) => setPartnerForm({ ...partnerForm, phone: e.target.value })}
                  required
                  placeholder="+996 XXX XXX XXX"
                />
              </div>
            </div>
            <div className={styles.inputGroup}>
              <label>Тип партнерства *</label>
              <select
                value={partnerForm.partnership}
                onChange={(e) => setPartnerForm({ ...partnerForm, partnership: e.target.value })}
                required
              >
                <option value="">Выберите тип</option>
                <option value="reseller">Реселлер</option>
                <option value="integration">Интеграция</option>
                <option value="investment">Инвестиции</option>
                <option value="marketing">Маркетинг</option>
                <option value="other">Другое</option>
              </select>
            </div>
            <div className={styles.inputGroup}>
              <label>Предложение *</label>
              <textarea
                value={partnerForm.message}
                onChange={(e) => setPartnerForm({ ...partnerForm, message: e.target.value })}
                required
                rows="4"
                placeholder="Расскажите о вашем предложении..."
              />
            </div>
            <button type="submit" className={styles.submitButton}>
              Отправить предложение
            </button>
          </form>
        </div>
      </div>

      <div className={styles.mapSection}>
        <h2 className={styles.sectionTitle}>Мы всегда на связи</h2>
        <p className={styles.sectionSubtitle}>
          Работаем для вас 24/7. Выберите удобный способ связи!
        </p>
        <div className={styles.statsRow}>
          <div className={styles.statItem}>
            <div className={styles.statNumber}>&lt; 2 часа</div>
            <div className={styles.statLabel}>Среднее время ответа</div>
          </div>
          <div className={styles.statItem}>
            <div className={styles.statNumber}>99.5%</div>
            <div className={styles.statLabel}>Довольных клиентов</div>
          </div>
          <div className={styles.statItem}>
            <div className={styles.statNumber}>24/7</div>
            <div className={styles.statLabel}>Поддержка</div>
          </div>
        </div>
      </div>

    {/* Success / Error Modal */}
    {successModal.show && (
      <div className={styles.modalOverlay} onClick={() => setSuccessModal({ ...successModal, show: false })}>
        <div className={styles.modalBox} onClick={(e) => e.stopPropagation()}>
          <div className={`${styles.modalIcon} ${successModal.isError ? styles.modalIconError : styles.modalIconSuccess}`}>
            {successModal.isError ? '✕' : '✓'}
          </div>
          <h3 className={styles.modalTitle}>{successModal.title}</h3>
          <p className={styles.modalMessage}>{successModal.message}</p>
          <button
            className={styles.modalBtn}
            onClick={() => setSuccessModal({ ...successModal, show: false })}
          >
            Закрыть
          </button>
        </div>
      </div>
    )}
  </div>
  )
}

export default ContactsPage
